import { Skeleton } from "@/components/ui/skeleton"

const CATEGORY_PLACEHOLDERS = [
  { id: 1, labelWidthClassName: "w-36", depthPaddingClassName: "" },
  { id: 2, labelWidthClassName: "w-28", depthPaddingClassName: "ps-6" },
  { id: 3, labelWidthClassName: "w-24", depthPaddingClassName: "ps-10" },
  { id: 4, labelWidthClassName: "w-32", depthPaddingClassName: "" },
  { id: 5, labelWidthClassName: "w-26", depthPaddingClassName: "ps-6" },
] as const

export const StoreCategoriesSidebarSkeleton = (): React.ReactNode => {
  return (
    <aside className='h-fit rounded-xl border border-gray-200 bg-gray-50 p-4 lg:sticky lg:top-24'>
      <Skeleton className='h-7 w-30 rounded-md' />

      <div className='mt-4'>
        <Skeleton className='h-9 w-full rounded-md' />
      </div>

      <div className='mt-3 space-y-2'>
        {CATEGORY_PLACEHOLDERS.map((placeholder) => (
          <div
            className={`flex items-center justify-between gap-3 ${placeholder.depthPaddingClassName}`}
            key={placeholder.id}
          >
            <Skeleton className={`h-4 ${placeholder.labelWidthClassName}`} />
            <Skeleton className='h-3 w-6 rounded-sm' />
          </div>
        ))}
      </div>
    </aside>
  )
}
